
import PhotoThumbnail from './components/PhotoThumbnail';

export default {
  i18nComponentKey: 'WidgetProductReviewsPhotoThumbnail.WidgetProductReviewsPhotoThumbnailMobile',
  name: 'WidgetProductReviewsPhotoThumbnailMobile',
  components: { PhotoThumbnail }
};
